/**
 *  variables to manage a player for a grid like game
 * 
 */

import { gSettings } from "../settings/gamesettings";
import * as blk from "./TetShapes.js"

export default class GridPlayer {

 // declare varibles here
 debug = false;
 playerNo = 1; // the player No 
 level = 1;
 score = 0;
 ratScore = 0;
 linesCleared = 0;
 ratsHomed = 0;
 comboAmount = 0;
 curPosX = gSettings.GAME_GRID_SIZE_X / 2;
 hardDropOn = false;
 curPosY = 0;
 curRot = 0;
 rotV = 0;
 brickData = 1;
 brickIndex = -1; // the current brickIndex
 brickBag = []; // bricks are drawn from a bag of evently randomised shapes
 rotationAttempts = 0;
 rotationCoolDown = 0;

 color = 0xff0000;

 autoMove = true;
 autoMoveTim = 0;
 autoMoveTimeOut = 2000;
 autoMoveForce = false;

 gridPosXCent = 0;
 gridPosXRight    = 0;
 gridPosXLeft    = 0;
 gridPosYBot = 0;
 gridPosYTop = 0;
 mosXY = [0,0,0];
 // 
 posChanged = true;
 redrawNext = false;
 // controls
 hardDropPlaced = false;

 moveLeft 	= 0; 
 moveRight	= 0;
 rotLeft 	= 0;
 rotRight 	= 0;
 moveUp     = 0;
 slowDrop   = 0;
 hardDrop   = 0;
 slowDropAlt   = 0;
 hardDropAlt   = 0;


 btnMoveLeft = false;
 btnMoveRight = false;
 btnRotateCW = false;
 btnRotateCCW = false;
 btnDrop = false;
 btnHardDrop = false;
 

 holdPiece  = 0;
 pauseButton = 0;
 velX = 0;
 velY = 0;
 velR = 0; // rotation velocitiy
 refresh = false;

 lastSlowDropMov = 0;
 lastLfRtDropMov = 0;
    constructor(playerNo = 1, color) {
        this.playerNo = playerNo;
        this.color = color;

        if (color == 0) {
            this.color = 0x920072;
        }
        if (color == 1) {
            this.color = 0x24ba94;
        }
        if (color == 2) {
            this.color = 0xf4e8c7;
        }
        if (color == 3) {
            this.color = 0xEBD9EF;
        }
        if (color == 4) {
            this.color = 0xB6E1B8;
        }

        this.initPlayer()
    }

    setLevel(level) {
        this.level = level;
        if (this.level > 20) this.level = 20;
        if (this.level < 0) this.level = 0;
        
        this.autoMoveTimeOut = gSettings.LEVEL_SPEEDS[level];
    }

    initPlayer(startingLevel = 1) {
        this.score = 0;
        this.ratScore = 0;
        this.setLevel(startingLevel);
        this.curPosX = 4;
        this.curPosY = 0;
        this.linesCleared = 0;
        this.nextBrick();
        if (gSettings.NO_GRAVITY) {
            this.autoMove = false;
        } else {
            this.autoMove = true;
        }
        this.comboAmount = 0;
        this.ratsHomed = 0;
        this.redrawNext = true;
        this.rotationCoolDown = 0;
        this.rotationAttempts = 0;
        this.hardDropPlaced = false;
 
    }

    setBrick(brickData, rotation = 0) {
        this.curRot = rotation;
        this.brickData = brickData;
    }

    nextBrick() {
        this.curPosY = 0;
        if (gSettings.NEXT_BRICK_ALWAYS_IN_CENTER) {
            this.curPosX = (gSettings.GAME_GRID_SIZE_X / 2) -2;
        }
        this.autoMoveTim =0;
        this.refresh = true;
        if (this.brickBag.length <= 4) {

            let newBag = blk.getRandomBagOfBlks();

            for (let i = 0; i < newBag.length; i++) {
                this.brickBag.push(newBag[i]);
            }
            
        } 
        this.brickIndex = this.brickBag.shift();
        this.brickData = blk.blkTypes[this.brickIndex]; // grab the next in the bag
     
        this.velX = 0;
        this.velY = 0;
        this.curRot = 0;

        if (this.curPosX < 0) this.curPosX = 0;


        if (this.brickIndex == 0 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 2) this.curPosX -= 1;
        else if (this.brickIndex == 1 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 2) this.curPosX -= 1;
        else if (this.brickIndex == 2 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 2) this.curPosX -= 1;
        else if (this.brickIndex == 3 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 1) this.curPosX -= 1;
        else if (this.brickIndex == 4 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 2)  this.curPosX -= 1;
        else if (this.brickIndex == 5 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 2) this.curPosX -= 1;
        else if (this.brickIndex == 6 && this.curPosX >= gSettings.GAME_GRID_SIZE_X - 3) this.curPosX -= 2;

        // default fix
        if (this.curPosX >= gSettings.GAME_GRID_SIZE_X - 2) this.curPosX -= 1;
        this.autoMoveForce = true;
        this.refresh = true;
        this.redrawNext = true;

    }


    rotateBlk() {



        this.curRot += this.velR;
    
        if (this.curRot < 0) this.curRot = 3;
        else if (this.curRot > 3) this.curRot = 0;
        this.velR = 0;


        // rotation fixes -- for z and s
        if (this.curPosY > 0) {
        
            if (this.brickIndex == 0 || this.brickIndex == 1 ) {
            if (this.curRot == 1 || this.curRot == 3)
                this.velY += -1;
            else 
                this.velY += 1;
        }
        // rotation fixes -- for i
        if (this.brickIndex == 6 ) {
            if (this.curRot == 1 || this.curRot == 3)
                this.velY += -1;
            else 
                this.velY += 1;
        }
        }

    }


    inputChk(time, delta) {


        if (this.autoMove) this.autoMoveTim += delta;

		// keys for player






        if (Phaser.Input.Keyboard.JustDown( this.rotLeft) || this.btnRotateCCW ) 
        {
			this.velR += -1;
            this.btnRotateCCW = false;
	
        }

        else if (Phaser.Input.Keyboard.JustDown( this.rotRight) || this.btnRotateCW  ) 
        {
            this.btnRotateCW = false;
   			this.velR += 1;
			
        }





            if (Phaser.Input.Keyboard.JustDown( this.moveLeft) || this.moveLeft.getDuration() > gSettings.KEY_HOLD_WAIT_TIME && this.lastLfRtDropMov < time || this.btnMoveLeft) 
            {
;
                this.lastLfRtDropMov = time + gSettings.LFRT_DROP_DELAY
                    if (this.debug)consoe.log("move left");
    
                this.velX += -1;
                this.btnMoveLeft = false;

            }
            if (Phaser.Input.Keyboard.JustDown( this.moveRight) || this.moveRight.getDuration() > gSettings.KEY_HOLD_WAIT_TIME && this.lastLfRtDropMov < time || this.btnMoveRight) 
            {
                this.lastLfRtDropMov = time + gSettings.LFRT_DROP_DELAY;
                this.btnMoveRight = false;
                    if (this.debug)consoe.log("move moveright");
                this.velX += 1;
            

            }


            if (Phaser.Input.Keyboard.JustDown( this.hardDrop) || Phaser.Input.Keyboard.JustDown( this.hardDropAlt) || this.btnHardDrop ) 
            {
                if (this.debug)consoe.log("hard Drop");
                this.hardDropOn = true;
                this.refresh = true;
                this.btnHardDrop = false;
                
            }
            if (this.slowDrop.isDown || this.slowDropAlt.isDown ||  this.btnDrop) // how to do is dowwn event
            {
            

                if (this.curPosY < gSettings.GAME_GRID_SIZE_Y && this.lastSlowDropMov < time) {
                    this.lastSlowDropMov = time + gSettings.SLOW_DROP_DELAY;
                    if (this.debug)consoe.log("move down");
                    this.velY += 1;
                    this.PlayerMovedY = 1;
                    this.autoMoveTim = 0;
                }
                this.btnDrop = false;

            }
            if (this.debug) {
                if (Phaser.Input.Keyboard.JustDown(this.moveUp)) 
                {
            
                    if (this.curPosY > 0) {
                
                        if (this.debug)consoe.log("move up");
                        this.velY += -1;
                    
                    }
            }
        
        }



        this.update(time);
    }

    colChk() {
        if (this.curPosX +  this.velX < gSettings.GAME_GRID_SIZE_X - 1 || this.curPosX + this.velX > 0) {

            this.oCurPosX = this.curPosX;
            this.curPosX += this.velX ;
            this.posChanged = true;
            
        }
        if (this.curPosY + this.velY < gSettings.GAME_GRID_SIZE_Y - 1 || this.curPosY + this.velY > 0) {
      

            this.oCurPosY = this.curPosY;
            this.curPosY += this.velY;
            this.posChanged = true;
            
            // colChk with bottom
            if (this.curPosY == gSettings.GAME_GRID_SIZE_Y - 1) this.setBrick = true
        }
    }
    
    update(time) {

        // if rotation has been pressed - kill off any velocity this prevents funny hacks   
        // stops rotation and 
        // rotation attempts also tries to stop spammers

        // all this code is to prevent spamming but it doesn't really work...
        // so leave it commeted out as doesn't really fix anything

        /*
        if (this.velR != 0  ) {
            this.velY = 0;
            this.velX = 0;                       
            this.rotationAttempts++;
            this.rotationCoolDown = time + 250;
        }
        
        if (this.velX != 0) {
            this.velY = 0;
        }
        


        if (this.rotationCoolDown < time)
            this.rotationAttempts = 0;
        if (this.rotationAttempts > 3 && this.rotationCoolDown > time ) {
            console.log("too many rotations!");
            this.velR  = 0;
            this.rotationCoolDown = 0;
            this.autoMoveForce = true;
        }
*/

        if (this.autoMoveTim > this.autoMoveTimeOut || this.autoMoveForce) {
            if (this.velY == 0) this.velY += 1;
            this.autoMoveTim = 0;
            this.autoMoveForce = false;
        }

   
    }

    oldPosUpdate() {

        this.oCurPosX = this.curPosX;
        this.oCurPosY = this.curPosY;
        this.posChanged = false;
    }





    draw() {

    }

}